import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme)=> {
    return {
            container: {
                display: 'flex',
                flex: 1,
                flexDirection: "row",
                width: '100%',
                justifyContent: "justify-between",
                borderRadius: 0,
                padding: '8px',
                alignItems: 'center'
            },
            item: {
                '&:not(first-child)': {
                    marginLeft: theme.spacing(1)
                }
            }
        }
})